(function () {
  const qs = (sel, ctx = document) => ctx.querySelector(sel);
  const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  function initMenu() {
    const header = qs('[data-site-header]');
    const toggle = qs('[data-menu-toggle]');
    if (!header || !toggle) return;
    toggle.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) closeAllMega(header);
    });
  }

  function closeAllMega(root) {
    qsa('[data-mega-item]', root).forEach((item) => {
      item.classList.remove('is-open');
      const trigger = qs('[data-mega-trigger]', item);
      const panel = qs('[data-mega-panel]', item);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  function initMegaMenu() {
    const nav = qs('[data-mega-nav]');
    if (!nav) return;
    const header = qs('[data-site-header]');
    const items = qsa('[data-mega-item]', nav);

    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

    items.forEach((item) => {
      const trigger = qs('[data-mega-trigger]', item);
      const panel = qs('[data-mega-panel]', item);
      if (!trigger || !panel) return;

      const open = () => {
        items.forEach((other) => {
          if (other !== item) {
            other.classList.remove('is-open');
            const t = qs('[data-mega-trigger]', other);
            const p = qs('[data-mega-panel]', other);
            if (t) t.setAttribute('aria-expanded', 'false');
            if (p) p.hidden = true;
          }
        });
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      };

      const close = () => {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      };

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (item.classList.contains('is-open')) close();
        else open();
      });

      item.addEventListener('mouseenter', () => {
        if (!isMobile()) open();
      });
      item.addEventListener('mouseleave', () => {
        if (!isMobile()) close();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && header) closeAllMega(header);
    });

    document.addEventListener('click', (e) => {
      if (!header) return;
      if (!header.contains(e.target)) closeAllMega(header);
    });
  }

  let cartDrawer = null;

  function initCartDrawer() {
    const drawer = qs('[data-cart-drawer]');
    if (!drawer) return;

    const open = () => {
      // Force a reflow first so a just-refreshed panel (new DOM from add-to-cart)
      // still animates in instead of popping straight to the open state.
      void drawer.offsetHeight;
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    const refresh = (html) => {
      if (!html) return;
      const temp = document.createElement('div');
      temp.innerHTML = html.trim();
      const newDrawer = temp.querySelector('[data-cart-drawer]') || temp.firstElementChild;
      if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
    };

    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cart-open]');
      if (opener && drawer.dataset.cartType === 'drawer') {
        e.preventDefault();
        open();
      }
    });

    drawer.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-close]')) close();
    });

    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    cartDrawer = { open, close, refresh };
  }

  function updateCartLine(key, quantity) {
    if (!cartDrawer) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer' }),
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || data.message || 'Unable to update your cart.');
        if (data.sections && data.sections['cart-drawer']) {
          cartDrawer.refresh(data.sections['cart-drawer']);
        }
        qsa('[data-cart-count]').forEach((el) => {
          el.textContent = data.item_count;
        });
      })
      .catch(() => {
        // Resync from server truth if the update failed, so the drawer never shows a stale state.
        fetch('/?sections=cart-drawer')
          .then((res) => res.json())
          .then((sections) => {
            if (sections['cart-drawer']) cartDrawer.refresh(sections['cart-drawer']);
          })
          .catch(() => {});
      });
  }

  function initCartLineActions() {
    const drawer = qs('[data-cart-drawer]');
    if (!drawer || !cartDrawer) return;

    const debounceTimers = {};
    const scheduleUpdate = (key, quantity) => {
      clearTimeout(debounceTimers[key]);
      debounceTimers[key] = setTimeout(() => updateCartLine(key, quantity), 350);
    };

    drawer.addEventListener('click', (e) => {
      const minus = e.target.closest('[data-qty-minus]');
      const plus = e.target.closest('[data-qty-plus]');
      const removeBtn = e.target.closest('[data-cart-remove]');

      if (minus || plus) {
        const wrap = e.target.closest('[data-cart-qty]');
        const input = wrap && qs('[data-qty-input]', wrap);
        if (!wrap || !input) return;
        const current = parseInt(input.value, 10) || 1;
        const next = plus ? current + 1 : Math.max(1, current - 1);
        input.value = next;
        scheduleUpdate(wrap.dataset.lineKey, next);
        return;
      }

      if (removeBtn) {
        e.preventDefault();
        const key = removeBtn.dataset.lineKey;
        if (key) updateCartLine(key, 0);
      }
    });

    drawer.addEventListener('change', (e) => {
      if (!e.target.matches('[data-qty-input]')) return;
      const wrap = e.target.closest('[data-cart-qty]');
      if (!wrap) return;
      const next = Math.max(0, parseInt(e.target.value, 10) || 0);
      e.target.value = next;
      scheduleUpdate(wrap.dataset.lineKey, next);
    });
  }

  function initAjaxAddToCart() {
    if (!cartDrawer) return;

    qsa('[data-product-form]').forEach((form) => {
      const submitBtn = qs('button[type="submit"][name="add"]', form);
      const errorEl = qs('[data-cart-error]', form);

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
        if (submitBtn) submitBtn.disabled = true;

        const formData = new FormData(form);
        formData.append('sections', 'cart-drawer');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
          .then(({ ok, data }) => {
            if (!ok) {
              throw new Error(data.description || data.message || 'Unable to add this item to your cart.');
            }
            if (data.sections && data.sections['cart-drawer']) {
              cartDrawer.refresh(data.sections['cart-drawer']);
            }
            cartDrawer.open();
            return fetch('/cart.js').then((r) => r.json());
          })
          .then((cart) => {
            if (!cart) return;
            qsa('[data-cart-count]').forEach((el) => {
              el.textContent = cart.item_count;
            });
          })
          .catch((err) => {
            if (errorEl) {
              errorEl.textContent = err.message;
              errorEl.hidden = false;
            }
          })
          .finally(() => {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    });
  }

  function initSearch() {
    const bar = qs('[data-search-bar]');
    const toggle = qs('[data-search-toggle]');
    const closeBtn = qs('[data-search-close]', bar || document);
    if (!bar || !toggle) return;

    const input = qs('[data-search-input]', bar);
    const results = qs('[data-search-results]', bar);
    const currency = bar.dataset.currency || '';
    let debounceTimer = null;
    let lastQuery = '';

    const escapeHtml = (str) => String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

    const open = () => {
      bar.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => input && input.focus());
    };

    const close = () => {
      bar.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (results) {
        results.hidden = true;
        results.innerHTML = '';
      }
    };

    toggle.addEventListener('click', () => {
      if (bar.hidden) open();
      else close();
    });

    closeBtn && closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !bar.hidden) close();
    });

    document.addEventListener('click', (e) => {
      if (!bar.hidden && !bar.contains(e.target) && e.target !== toggle && !toggle.contains(e.target)) {
        close();
      }
    });

    if (!input || !results) return;

    const renderResults = (data, query) => {
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];

      if (products.length === 0) {
        results.innerHTML = `<p class="search-bar__empty">No results for &ldquo;${escapeHtml(query)}&rdquo;.</p>`;
        results.hidden = false;
        return;
      }

      const items = products.slice(0, 6).map((product) => `
        <a class="search-result" href="${product.url}">
          <span class="search-result__media">
            ${product.image ? `<img src="${product.image}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
          </span>
          <span class="search-result__meta">
            <span class="search-result__title">${escapeHtml(product.title)}</span>
            <span class="search-result__price">${escapeHtml(product.price)}${currency ? ' ' + escapeHtml(currency) : ''}</span>
          </span>
        </a>
      `).join('');

      const viewAllUrl = `${input.form.action}?q=${encodeURIComponent(query)}&type=product`;

      results.innerHTML = `
        <div class="search-results__list">${items}</div>
        <a class="search-results__view-all" href="${viewAllUrl}">View all results for &ldquo;${escapeHtml(query)}&rdquo;</a>
      `;
      results.hidden = false;
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(() => {
        if (query === lastQuery) return;
        lastQuery = query;
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`)
          .then((res) => res.json())
          .then((data) => renderResults(data, query))
          .catch(() => {
            results.hidden = true;
            results.innerHTML = '';
          });
      }, 250);
    });
  }

  function initProductGallery() {
    const root = qs('[data-product-gallery]');
    if (!root) return;
    const main = qs('[data-product-main]', root);
    const thumbs = qsa('[data-product-thumb]', root);
    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const src = btn.getAttribute('data-src');
        const srcset = btn.getAttribute('data-srcset');
        if (main && src) {
          main.src = src;
          if (srcset) main.srcset = srcset;
        }
        thumbs.forEach((t) => t.classList.toggle('is-active', t === btn));
      });
    });
  }

  function initImageZoom() {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!canHover) return;

    const wrap = qs('.product__main-image');
    const img = wrap && qs('[data-product-main]', wrap);
    if (!wrap || !img) return;

    const ZOOM = 2.5;
    const LENS_SIZE = parseInt(wrap.dataset.zoomLensSize, 10) || 150;
    const shape = wrap.dataset.zoomShape === 'square' ? 'square' : 'circle';

    let lens = qs('[data-zoom-lens]', wrap);
    if (!lens) {
      lens = document.createElement('div');
      lens.setAttribute('data-zoom-lens', '');
      lens.hidden = true;
      wrap.appendChild(lens);
    }
    lens.className = `product-zoom-lens product-zoom-lens--${shape}`;
    lens.style.width = `${LENS_SIZE}px`;
    lens.style.height = `${LENS_SIZE}px`;

    // Image renders via object-fit: contain, so it may be letterboxed inside
    // the (square) container. Zoom math needs the actual visible image box,
    // not the full container, or the lens content will look stretched.
    const getImageBox = (containerRect) => {
      const iw = img.naturalWidth;
      const ih = img.naturalHeight;
      if (!iw || !ih) {
        return { width: containerRect.width, height: containerRect.height, offsetX: 0, offsetY: 0 };
      }
      const containerRatio = containerRect.width / containerRect.height;
      const imgRatio = iw / ih;
      let width;
      let height;
      if (imgRatio > containerRatio) {
        width = containerRect.width;
        height = width / imgRatio;
      } else {
        height = containerRect.height;
        width = height * imgRatio;
      }
      return {
        width,
        height,
        offsetX: (containerRect.width - width) / 2,
        offsetY: (containerRect.height - height) / 2,
      };
    };

    const move = (e) => {
      const rect = wrap.getBoundingClientRect();
      const box = getImageBox(rect);

      let x = e.clientX - rect.left - box.offsetX;
      let y = e.clientY - rect.top - box.offsetY;
      x = Math.max(0, Math.min(x, box.width));
      y = Math.max(0, Math.min(y, box.height));

      // The visible frame is drawn at LENS_SIZE and centered on the cursor.
      const frameX = Math.max(0, Math.min(x - LENS_SIZE / 2, box.width - LENS_SIZE));
      const frameY = Math.max(0, Math.min(y - LENS_SIZE / 2, box.height - LENS_SIZE));
      lens.style.left = `${box.offsetX + frameX}px`;
      lens.style.top = `${box.offsetY + frameY}px`;

      // The region actually magnified is smaller than the frame (frame size
      // / zoom) — it must be centered using ITS OWN size, not the frame's,
      // or the zoomed content drifts away from the cursor.
      const captureSize = LENS_SIZE / ZOOM;
      const capX = Math.max(0, Math.min(x - captureSize / 2, box.width - captureSize));
      const capY = Math.max(0, Math.min(y - captureSize / 2, box.height - captureSize));

      lens.style.backgroundSize = `${box.width * ZOOM}px ${box.height * ZOOM}px`;
      lens.style.backgroundPosition = `-${capX * ZOOM}px -${capY * ZOOM}px`;
    };

    wrap.addEventListener('mouseenter', () => {
      const src = img.currentSrc || img.src;
      lens.style.backgroundImage = `url("${src}")`;
      lens.hidden = false;
    });

    wrap.addEventListener('mousemove', move);

    wrap.addEventListener('mouseleave', () => {
      lens.hidden = true;
    });
  }

  function initQty() {
    qsa('[data-qty]').forEach((wrap) => {
      const input = qs('input', wrap);
      const minus = qs('[data-qty-minus]', wrap);
      const plus = qs('[data-qty-plus]', wrap);
      if (!input) return;
      minus && minus.addEventListener('click', () => {
        const v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
      });
      plus && plus.addEventListener('click', () => {
        const v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMenu();
    initMegaMenu();
    initSearch();
    initCartDrawer();
    initCartLineActions();
    initAjaxAddToCart();
    initProductGallery();
    initImageZoom();
    initQty();
  });
})();
